import React from "react";
import styled, { keyframes } from "styled-components";

import T from "prop-types";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Wrapper = styled.div`
  @media (prefers-reduced-motion: no-preference) {
    animation-name: ${fadeIn};
    animation-fill-mode: backwards;
  }
`;

const FadeIn = ({ duration = 400, delay = 0, children, ...delegated }) => {
  return (
    <Wrapper
      {...delegated}
      style={{
        ...(delegated.style || {}),
        animationDuration: duration + "ms",
        animationDelay: delay + "ms",
      }}
    >
      {children}
    </Wrapper>
  );
};

FadeIn.propTypes = {
  duration: T.number,
  delay: T.number,
  children: T.oneOfType([T.object, T.string, T.node]),
};

export default FadeIn;
